import React from 'react';
import { Text } from '@moda/om';
import { FineJewelryReturnMessage } from '../FineJewelryReturnMessage';

interface Props {
  isFineJewelry: boolean;
  isFineJewelryReturnPolicyCovered: boolean;
  isReturnable: boolean;
  message: string;
  status: string;
}

export const OrderItemDetailsReturnPolicyMessage: React.FC<Props> = ({
  isFineJewelry,
  isFineJewelryReturnPolicyCovered,
  isReturnable,
  message,
  status
}) => {
  if (isReturnable) {
    if (isFineJewelry) {
      if (status === 'shipped' && isFineJewelryReturnPolicyCovered) {
        return <FineJewelryReturnMessage />;
      } else return null;
    } else return <Text>{message}</Text>;
  }

  return null;
};
